// extracted by mini-css-extract-plugin
export default {"toggle":"toggle--1utTK","icon":"icon--2Suij","title":"title--VNP1y","open":"open--ke8QO","listItem":"listItem--3Hhwb","link":"link--lKEZ2","activeLink":"activeLink--2zgyo"};